import React, { useState, useEffect } from 'react';
import { Play, Pause, Loader2, Music } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ListenPage = ({ slug, guestToken = null }) => {
  const [beat, setBeat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const bodyOverflow = document.body.style.overflow;
    const root = document.getElementById('root');
    const rootOverflow = root?.style.overflow;
    document.body.style.overflow = 'auto';
    if (root) root.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = bodyOverflow;
      if (root) root.style.overflow = rootOverflow;
    };
  }, []);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/v1/platform/${guestToken ? 'guest-listen' : 'listen'}/${guestToken || slug}`)
      .then(r => { if (!r.ok) throw new Error('Not found'); return r.json(); })
      .then(setBeat)
      .catch(() => setError('This beat is no longer available.'))
      .finally(() => setLoading(false));
  }, [slug, guestToken]);

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Loader2 size={32} className="animate-spin" style={{ color: '#00D4AA' }} />
    </div>
  );

  if (error || !beat) return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#666', gap: 12 }}>
      <Music size={40} />
      <span style={{ fontSize: 16 }}>{error || 'Beat not found'}</span>
      <a href="https://letthebeatbuild.me" style={{ fontSize: 13, color: '#00D4AA', textDecoration: 'none' }}>Learn about LTBB programs</a>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', color: '#fff', fontFamily: "'Barlow', 'Inter', sans-serif" }}>
      <div style={{ maxWidth: 500, margin: '0 auto', padding: '40px 20px', textAlign: 'center' }}>
        <img src="/Pizzul_Hero.png" alt="" style={{ width: 64, height: 64, borderRadius: '50%', border: '2px solid #00D4AA', objectFit: 'cover', margin: '0 auto 20px' }} />
        <h1 style={{ fontSize: 24, fontWeight: 700, margin: '0 0 4px' }}>{beat.name}</h1>
        {!guestToken && <><p style={{ fontSize: 14, color: '#aaa', margin: '0 0 6px' }}>by {beat.creator}</p>
        <p style={{ fontSize: 12, color: '#666', margin: '0 0 30px' }}>{beat.bpm} BPM &middot; {beat.total_bars} bars</p></>}
        <div style={{ background: '#1A1A1A', borderRadius: 16, padding: '24px', border: '1px solid #2A2A2A' }}>
          {guestToken ? <audio controls src={beat.audio_url} style={{ width: '100%' }}>Your browser does not support audio playback.</audio> : <>
            <p style={{ fontSize: 13, color: '#666' }}>Audio playback coming soon</p>
            <p style={{ fontSize: 11, color: '#444', marginTop: 8 }}>This beat has {(beat.arrangement_data?.tracks || []).length} tracks</p>
          </>}
        </div>
        {guestToken && <>
          <a href={beat.audio_url} style={{ display: 'block', marginTop: 16, background: '#00D4AA', color: '#07110f', padding: '13px 16px', borderRadius: 24, fontWeight: 700, textDecoration: 'none' }}>Download my beat</a>
          <p style={{ color: '#c4c4c4', fontSize: 13, lineHeight: 1.4, margin: '10px 0 0' }}>This link works for 7 days, so save it now.</p>
        </>}
        <div style={{ marginTop: 30 }}>
          <a href="https://letthebeatbuild.me" style={{ fontSize: 13, color: '#00D4AA', textDecoration: 'none', fontWeight: 600 }}>Learn about LTBB programs</a>
        </div>
      </div>
    </div>
  );
};

export default ListenPage;
